// This is a bit of a hack. Might need to fix the exported types in the client-auth package
import { BLAuth } from "@brandlive1941/client-auth";

type FromAppConfig = NonNullable<InstanceType<typeof BLAuth>["fromAppConfig"]>;

const BRAND_TV_DOMAIN = import.meta.env.VITE_BRAND_TV_DOMAIN as string;
const WEBINAR_PLUS_DOMAIN = import.meta.env.VITE_WEBINAR_PLUS_DOMAIN as string;

const BRANDTV_AUTH_CONFIG_STR = import.meta.env.VITE_BRAND_TV_AUTH_CONFIG as string;
const WEBINAR_PLUS_AUTH_CONFIG_STR = import.meta.env.VITE_WEBINAR_PLUS_AUTH_CONFIG as string;

export const BRANDTV_AUTH_CONFIG = (BRANDTV_AUTH_CONFIG_STR ? JSON.parse(BRANDTV_AUTH_CONFIG_STR) : {}) as FromAppConfig;
export const WEBINAR_PLUS_AUTH_CONFIG = (WEBINAR_PLUS_AUTH_CONFIG_STR ? JSON.parse(WEBINAR_PLUS_AUTH_CONFIG_STR) : {}) as FromAppConfig;

export const getFromAppConfigForCurrentLocation = () => {
	try {
		if (window.location.hostname.endsWith(BRAND_TV_DOMAIN)) {
			return BRANDTV_AUTH_CONFIG;
		}

		if (window.location.hostname.endsWith(WEBINAR_PLUS_DOMAIN)) {
			return WEBINAR_PLUS_AUTH_CONFIG;
		}
	} catch (error) {
		console.error('Error parsing from app config', error);
	}

	return { fromApp: 'Brandlive Platform' };
};

